<template>
  <div class="bet-panel-container" :style="{ transform: 'scale(' + scaleRatio + ')', 'max-height': maxHeight }">
    <BettingZone />
    <!--
      Empty everywhere else. The desktop single view puts the arena rail here,
      directly under the bet zone, which is where the design has it.
    -->
    <slot name="under-zone" />
    <GameStatus
      v-if="showStatus && (!isMobile || isMobileLandscape)"
      :active="active"
      @jackpotCollectPopup="$emit('jackpotCollectPopup')"
      @jackpotPhysicalPopup="$emit('jackpotPhysicalPopup')"
    />
    <FunctionBtns />
  </div>
</template>
<script>
import FunctionBtns from '@/components/bet-panel/function-btns.vue';
import BettingZone from '@/components/bet-panel/bet-zone/index.vue';
import GameStatus from '@/components/bet-panel/game-status.vue';
import { isMobile, isIOS } from 'mobile-device-detect';
import { mapGetters } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    /*
     * False when the caller shows GameStatus somewhere else -- the desktop pane
     * lifts it into its own info band, where the design puts the fight status
     * and the jackpot pill.
     */
    showStatus: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FunctionBtns,
    BettingZone,
    GameStatus,
  },
  data() {
    return {
      isMobile,
    };
  },
  computed: {
    ...mapGetters({
      ratio: 'general/inputPanelScaleRatio',
    }),
    maxHeight() {
      const offset = isIOS ? 15 : 0;
      return this.scaleRatio === 1 ? 'auto' : `${Math.max(this.scaleRatio * 250 + offset, 200)}px`;
    },
    isMobileLandscape() {
      return isMobile && this.$screen.width > this.$screen.height;
    },
    scaleRatio() {
      if (!isMobile) return this.ratio.landscape;
      if (this.isMobileLandscape) return isIOS ? this.ratio.landscape : this.ratio.landscape - 0.15;
      return this.ratio.vertical;
    },
  },
};
</script>
<style lang="scss" scoped>
.bet-panel-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: top center;

  > div {
    margin-top: 10px;
    &:first-of-type {
      margin-top: -21px;
    }
    @at-root .mobile #{&} {
      margin-top: 8px;
    }
  }
  @media (max-width: $tablet-portrait-width) {
    > div {
      &:first-of-type {
        margin-top: 0;
      }
    }
  }
}
</style>
